import React, { useState, useEffect } from 'react';
import './survey.css';

import { SendFeedback } from '../../api/StoreService';
import { IFeedback } from '../../types/IFeedback';

const Survey: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [errors, setErrors] = useState<string[]>([]);

  const [finding, setFinding] = useState('');
  const [liked, setLiked] = useState('');
  const [improvements, setImprovements] = useState('');

  useEffect(() => {
    const timer = setTimeout(() => {
      const feedbackSend = localStorage.getItem('survey-submitted_4') === 'true';
      setIsVisible(!feedbackSend);
    }, 180000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (submitted) {
      const thankYouTimer = setTimeout(() => {
        setSubmitted(false);
      }, 5000);
      return () => clearTimeout(thankYouTimer);
    }
  }, [submitted]);

  const submitSurvey = async () => {
    if (!finding && !liked && !improvements) {
      setErrors(['Uzupełnij przynajmniej jedno pole.']);
      return;
    }

    const feedback: IFeedback = {
      finding,
      liked,
      improvements
    };

    setIsSubmitting(true);

    try {
      await SendFeedback(feedback);
      setSubmitted(true);
      localStorage.setItem('survey-submitted_4', 'true');
      setTimeout(() => setIsVisible(false), 5000);
    } catch (error: any) {
      if (error.response?.data?.errors) {
        setErrors(error.response.data.errors);
      } else {
        setErrors(['Wystąpił błąd podczas wysyłki.']);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeSurvey = () => setIsVisible(false);

  return (
    <>
      {isVisible && !submitted && (
        <div className="survey-popup">
          <div className="survey-container">
            <button onClick={closeSurvey} className="close-button">x</button>
            <h2>Podziel się swoją opinią</h2>
            <p className="feedback-description">
              Twoja opinia pomoże ulepszyć mój katalog polskich sklepów!
            </p>

            <label htmlFor="finding">Czy łatwo było Ci znaleźć interesujące Cię ubrania?</label>
            <textarea
              id="finding"
              value={finding}
              onChange={e => setFinding(e.target.value)}
              rows={2}
              maxLength={1000}
            />
            <small>{finding.length}/1000</small>

            <label htmlFor="liked">Co najbardziej Ci się podoba na stronie?</label>
            <textarea
              id="liked"
              value={liked}
              onChange={e => setLiked(e.target.value)}
              rows={2}
              maxLength={1000}
            />
            <small>{liked.length}/1000</small>

            <label htmlFor="improvements">Co według Ciebie warto by poprawić na stronie?</label>
            <textarea
              id="improvements"
              value={improvements}
              onChange={e => setImprovements(e.target.value)}
              rows={2}
              maxLength={1000}
            />
            <small>{improvements.length}/1000</small>

            <button
              className="feedbackButton"
              onClick={submitSurvey}
              disabled={isSubmitting}
              style={{
                backgroundColor: isSubmitting ? '#ccc' : '#007bff',
                cursor: isSubmitting ? 'not-allowed' : 'pointer'
              }}
            >
              {isSubmitting ? (
                <span className="feedback-loader"></span>
              ) : (
                'Prześlij opinię'
              )}
            </button>

            {errors.length > 0 && (
              <div className="error-message">
                {errors.map((error, idx) => (
                  <p key={idx} style={{ color: 'red', fontSize: '14px' }}>{error}</p>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {submitted && (
        <div className="thank-you-modal show">
          <div className="typ-content">
            <h3 className="thanks">Dziękuję!</h3>
            <p className="thanks">Twoja opinia została przesłana 🙌</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Survey;
